import React from "react";
import Spline from "@splinetool/react-spline";

const SplineScene = () => {
  return (
    <Spline
      className="h-10"
      scene="https://prod.spline.design/9dTjW8kozdkmv1jo/scene.splinecode"
    />
  );
};

export default SplineScene;
